import {XHTTP} from '@/shared/xhttp';
import {TransporteurService} from "@/xhttp";
import {Fournisseur} from '@/models/Fournisseur';
import {Vente} from "@/models/Vente";

@XHTTP(TransporteurService, '/transporteurs')
export class Transporteur {
	
	private _id: number;
	private _listOrder: number;
	private _Name: string;
	private _address: string;
	private _zipCode: string;
	private _town: string;
	private _country: string;
	private _email: string;
	private _phone: string;
	private _vente: Vente[];
	private _createdAt: Date;
	
	/////////////
	// Getters //
	/////////////
	
	public get id(): number {
		return this._id;
	}
	
	public get listOrder(): number {
		return this._listOrder;
	}
	
	public get Name(): string {
		return this._Name;
	}

	public get address(): string {
		return this._address;
	}

	public get zipCode(): string {
		return this._zipCode;
	}

	public get town(): string {
		return this._town;
	}

	public get country(): string {
		return this._country;
	}

	public get fullAddress(): string {
		return (this.address.trim()+' '+this.zipCode.trim()+' '+this.town.trim()).trim();
	}

	public get fullName(): string {
		return this.Name.trim();
	}
	
	public get email(): string {
		return this._email;
	}
	
	public get phone(): string {
		return this._phone;
	}

	public get vente(): Vente[] {
		return this._vente;
	}
	
	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////
	
	public set listOrder(value: number) {
		this._listOrder = value;
	}
	
	public set Name(value: string) {
		this._Name = value;
	}
	
	public set address(value: string) {
		this._address = value;
	}

	public set zipCode(value: string) {
		this._zipCode = value;
	}

	public set town(value: string) {
		this._town = value;
	}

	public set country(value: string) {
		this._country = value;
	}
	
	public set email(value: string) {
		this._email = value;
	}
	
	public set phone(value: string) {
		this._phone = value;
	}

	public set createdAt(value: Date) {
		this._createdAt = value;
	}
	
	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id       : this._id,
			listOrder       : this._listOrder,
			Name: this._Name,
			address : this._address,
			zipCode : this._zipCode,
			town : this._town,
			country : this._country,
			email    : this._email,
			phone   : this._phone,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._listOrder        = data.listOrder;
		this._Name = data.Name;
		this._address  = data.address;
		this._zipCode  = data.zipCode;
		this._town  = data.town;
		this._country  = data.country;
		this._email     = data.email;
		this._phone    = data.phone;
		this._vente = data.vente ? data.vente.map(c => (new Vente()).fromJSON(c)) : null;
		this._createdAt = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}
